import styled from 'styled-components/macro';
import { Field } from 'formik';

export const Input = styled(Field)`
  position: relative;

  width: 100%;
  height: 2.5rem;
  padding: ${({ theme }) => theme.spacing.zero} ${({ theme }) => theme.spacing.zero_3};
  border: 1px solid;
  border-color: ${props =>
    props.error === 'hasError' ? props.theme.colors.negative_dark : props.theme.colors.black_10};
  border-radius: ${({ theme }) => theme.spacing.zero_1};

  ::placeholder {
    color: ${({ theme }) => theme.colors.black};
  }

  background-color: ${({ theme }) => theme.colors.white};
  outline: none;

  :focus {
    border: 1px solid;
    border-color: ${props =>
      props.error === 'hasError' ? props.theme.colors.negative_dark : props.theme.colors.black};
  }
  :read-only:not(:disabled) {
    background-color: ${({ theme }) => theme.colors.black_5};

    cursor: default;
  }
  :disabled {
    color: ${({ theme }) => theme.colors.black_40};

    background-color: ${({ theme }) => theme.colors.black_5};

    cursor: not-allowed;
  }
`;
